import { getTenantConfig } from './tenantConfig';

export function applyTenantTheme(hostname = window.location.hostname) {
  const tenant = getTenantConfig(hostname);
  const { theme, displayName, tenantKey } = tenant;
  const root = document.documentElement;

  root.style.setProperty('--brand-primary', theme.primary);
  root.style.setProperty('--brand-primary-hover', theme.primaryHover);
  root.style.setProperty('--brand-sidebar', theme.sidebar);
  root.style.setProperty('--brand-sidebar-hover', theme.sidebarHover);
  root.style.setProperty('--brand-accent', theme.accent);
  root.style.setProperty('--brand-heading', theme.heading);
  root.style.setProperty('--brand-action', theme.action);
  root.style.setProperty('--brand-action-hover', theme.actionHover);
  root.style.setProperty('--primary-color', theme.primary);

  root.dataset.tenant = tenantKey;
  document.title = displayName;

  const themeColorMeta = document.querySelector('meta[name="theme-color"]');
  if (themeColorMeta) {
    themeColorMeta.setAttribute('content', theme.themeColor);
  }

  return tenant;
}
